import httpClient from '@/http-client'
import { sum } from 'lodash'

export const dailyItemUsed = data => {
  return httpClient
    .get('/api/v1/reports/projects/daily-item-useds', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const dailyItemUsedExcel = data => {
  return httpClient
    .post('/api/v1/reports/projects/daily-item-useds/excels', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}

export const dailyTaskUpdate = data => {
  return httpClient
    .get('/api/v1/reports/projects/daily-task-updates', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const detailProject = data => {
  return httpClient
    .post('/api/v1/reports/projects/detail-projects', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const performances = data => {
  return httpClient
    .post('/api/v1/reports/projects/performances', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const siteCheckInOut = data => {
  return httpClient
    .post('/api/v1/reports/projects/site-check-in-out', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const borrowingByProject = data => {
  return httpClient
    .post('/api/v1/reports/projects/borrowing-by-projects', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const summaryMaterial = data => {
  return httpClient
    .post('/api/v1/reports/projects/summary-material-useds', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const projectList = data => {
  return httpClient
    .post('/api/v1/reports/projects/project-lists', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const materialClearanceByProject = data => {
  return httpClient
    .post('/api/v1/reports/projects/material-clearance-by-projects', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const detailProjectExcel = data => {
  return httpClient
    .post('/api/v1/reports/projects/detail-projects/excels', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}

export const performancesExcel = data => {
  return httpClient
    .post('/api/v1/reports/projects/performances/excels', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}

export const siteCheckInOutExcel = data => {
  return httpClient
    .post('/api/v1/reports/projects/site-check-in-out/excels', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}

export const dailyTaskUpdateExcel = data => {
  return httpClient
    .post('/api/v1/reports/projects/daily-task-updates/excels', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}

export const borrowingByProjectExcel = data => {
  return httpClient
    .post('/api/v1/reports/projects/borrowing-by-projects/excels', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}

export const summaryMaterialExcel = data => {
  return httpClient
    .post('/api/v1/reports/projects/summary-material-useds/excels', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}

export const projectListExcel = data => {
  return httpClient
    .post('/api/v1/reports/projects/project-lists/excels', data, {
      responseType: 'arraybuffer'
    })
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}

export const projectListPdf = data => {
  return httpClient
    .get('/api/v1/reports/projects/project-lists/pdf', {
      params: data
    })
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const materialClearanceByProjectExcel = data => {
  return httpClient
    .post(
      '/api/v1/reports/projects/material-clearance-by-projects/excels',
      data,
      {
        responseType: 'arraybuffer'
      }
    )
    .then(response => Promise.resolve(response))
    .catch(error => Promise.reject(error.response.data))
}

export const materialClearanceByProjectPdf = data => {
  return httpClient
    .get('/api/v1/reports/projects/material-clearance-by-projects/pdf', {
      params: data
    })
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const project = (options = {}) => {
  return httpClient
    .get('/api/v1/reports/projects/projects', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const creator = (options = {}) => {
  return httpClient
    .get('/api/v1/reports/projects/creators', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const site = (options = {}) => {
  return httpClient
    .get('/api/v1/reports/projects/sites', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const product = (options = {}) => {
  return httpClient
    .get('/api/v1/reports/projects/products', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const category = (options = {}) => {
  return httpClient
    .get('/api/v1/reports/projects/categories', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const owner = (options = {}) => {
  return httpClient
    .get('/api/v1/reports/projects/owners', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const ownerByProjects = (params = {}) => {
  return httpClient
    .get('/api/v1/reports/projects/owner-by-projects', { params })
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const borrowing = (params = {}) => {
  return httpClient
    .get('/api/v1/reports/projects/borrowing', { params })
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const status = (options = {}) => {
  return httpClient
    .get('/api/v1/reports/projects/status', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const customer = (options = {}) => {
  return httpClient
    .get('/api/v1/reports/projects/customers', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const task = (options = {}) => {
  return httpClient
    .get('/api/v1/reports/projects/tasks', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const milestone = (options = {}) => {
  return httpClient
    .get('/api/v1/reports/projects/milestones', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const requesters = (options = {}) => {
  return httpClient
    .get('/api/v1/reports/projects/requesters', options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const formViewModel = (Options = {}) => {
  return httpClient
    .get('/api/v1/reports/projects/form-view-models', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = (id, data) => {
  return httpClient
    .put(`/api/v1/reports/projects/${id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  dailyItemUsed,
  dailyItemUsedExcel,
  dailyTaskUpdate,
  dailyTaskUpdateExcel,
  project,
  creator,
  site,
  product,
  owner,
  status,
  customer,
  category,
  task,
  milestone,
  borrowing,
  requesters,
  ownerByProjects,
  detailProject,
  detailProjectExcel,
  siteCheckInOut,
  siteCheckInOutExcel,
  performances,
  performancesExcel,
  borrowingByProject,
  borrowingByProjectExcel,
  summaryMaterial,
  summaryMaterialExcel,
  projectList,
  projectListExcel,
  projectListPdf,
  materialClearanceByProject,
  materialClearanceByProjectExcel,
  materialClearanceByProjectPdf,
  formViewModel,
  update
}
